<template>
  <div class="play-page">
    <div class="play-card">
      <van-form label-width="5em">
        <van-field v-model="playParams.payAmount" label="支付金额"/>
        <van-field v-model="playParams.orderNo" label="订单号" />
        <van-field v-model="playMode" label="支付方式"/>
      </van-form>
      <van-button class="btn" round color="linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%)" v-if="isPlay" @click="play">立即支付</van-button>
      <van-button class="btn" round color="linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%)" v-else @click="goBack">
        {{ isReleaseActivity ? '发布活动': '支付完成'}}
      </van-button>
      
    </div>
  </div>
</template>

<script>
import loadingMixin from '@/mixins/loading-mixin'
export default {
  mixins: [loadingMixin],
  computed: {
    isReleaseActivity() {
      return this.playParams.source == 'activity'
    },
  },
  data() {
    return {
      isPlay: true,
      playMode: '微信支付',
      playParams: {},
      timer: null
    }
  },
  mounted() {
    this.playParams = this.$route.query
    console.log(this.playParams)
    if (this.timer) clearInterval(this.timer)
    this.timer = setInterval(() => {
      this.getRechargeOrderStatus()
    }, 1000)
  },
  methods: {
    play() {
      const { xcxLink } = this.playParams
      location.href= xcxLink
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getRechargeOrderStatus()
      }, 1000)
    },
    goBack() {
      const { source} = this.playParams
      if (this.isReleaseActivity) {
        this.release()
      } else if (source == 'recharge'){
        this.$emit('success')
        this.$router.go(-1)
      } else {
        this.$router.go(-1)
      }
    },
    getRechargeOrderStatus() {
      this.$api.h5.getRechargeOrderStatus(this.playParams.orderNo)
        .then(res => {
          if (res.data == 2) {
            this.isPlay = false
            clearInterval(this.timer)
          }
        }).catch(() => {
          clearInterval(this.timer)
        })
    },
     release() {
      const {activityId,orderNo} = this.playParams
      const params = {
        activityId, 
        orderNo
      };
      this.showLoading();
      return this.$api.activityMgmt.releaseActivity(params)
        .then(_ => {
          this.$toast('发布成功');
          this.$router.replace({
            path: '/home',
          });
        }).finally(() => {
           this.hideLoading();
        })
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="stylus" scoped>
  .play-page {
    display: flex;
    padding: 10px;
    .play-card {
      width: 100%;
      .btn {
        margin-top: 20px;
        width: 100%;
      }
    }
  }
</style>